module.exports = __webpack_public_path__ + "static/media/home.2785b25f.svg";